<template>
	<div style="position: relative;">
		<div style="min-height: 100vh;padding-bottom: 70px;box-sizing: border-box;" class="bg">
			<div style="text-align: center;">
				<img src="../assets/yure.png" style="width: 80%;padding-top: 5vh;"/>
			</div>
			<div v-if="!jy_flag" @click="xiazai" class="xiazai">下载客户端参与活动</div>
			<div v-if="jy_flag">
				<div class="kuang" style="text-align: center;">
					<div>
						<img src="../assets/ndyqm.png" style="width: 40%;"/>
					</div>
					<div class="yqm_div">
						<img src="../assets/srkbg.png" style="width: 100%;"/>
						<div class="yqm_text">{{my_invitecode}}</div>
					</div>
					<div style="margin-top: 20px;">
						<img src="../assets/liucheng.png" style="width: 100%;"/>
					</div>
					<div v-if="newusernum==0" class="wancheng">您已完成邀请任务，获得5积分</div>
					<div v-else style="margin-top: 20px;position: relative;font-size: 0;">
						<img src="../assets/zyq.png" style="width: 70%;"/>
						<div class="zyq_text">{{newusernum}}</div>
					</div>
				</div>
				<div class="kuang" style="text-align: center;">
					<div>
						<img src="../assets/txyqm.png" style="width: 40%;"/>
					</div>
					<div style="display: flex;justify-content: center;align-items: center;margin-top: 12px;">
						<input v-model="invitecode" class="yqmInput" type="text"/>
						<img @click="receive" src="../assets/tj2.png" style="width: 35%;"/>
					</div>
				</div>
			</div>
			
			<img src="../assets/logo.png" class="logo"/>
		</div>
		<div v-if="jz_flag" id="jiazai"
			style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 99;">
			<img src="../assets/loading.gif"
				style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
	</div>

</template>

<script>
	import {
		fwl,
		yr_loginin,
		yr_receive
	} from "@/api/index";
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	Vue.use(Toast);
	
	export default {
		name: 'warm',
		components: {

		},
		data() {
			return {
				jz_flag: false,
				invitecode:null,
				my_invitecode:null,
				newusernum:null,
				jy_flag:false
			}
		},

		methods: {
			xiazai(){
				var str1 = navigator.appVersion;
				var str2 = navigator.userAgent;
							
				var str = "pdmiryun";
				if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
					return true;
							
				} else {
					var u = navigator.userAgent;
					var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
					
					let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
					if (isIOS) {
						window.location.href = 'https://jiyun-applink.hebyun.com.cn/openLink?ios_schema=jiyun://main/detail?id=06237ffb3fda426e9729abb2afd317b6&contentType=1'
					} else{
						window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun&android_schema=jiyun%3A%2F%2Fmain%2Fdetail%3Fid%3D06237ffb3fda426e9729abb2afd317b6%26contentType%3D1%26linkType%3D1"
					}
					
				}
			},
			login(){
				let post = {
					"jytoken":tokenss
				}
				post = JSON.stringify(post)
				yr_loginin({
					message: post
				}).then(data => {
					console.log("data",data)
					data = data.data
					if(data.code==1){
						this.my_invitecode = data.data.invitecode
						this.newusernum = data.data.newusernum
					}else{
						Toast(data.msg);
					}
				}).catch(data => {
					Toast('服务器错误，请重试');
					
				})
			},
			receive(){
				if(!this.invitecode){
					Toast('请填写邀请码');
				}
				let post = {
					"jytoken": tokenss,
					"invitecode": this.invitecode
				}
				post = JSON.stringify(post)
				this.jz_flag = true
				yr_receive({
					message: post
				}).then(data => {
					data = data.data
					if(data.code==1){
						Toast('提交成功');
					}else{
						Toast(data.data);
					}
					this.jz_flag = false
				}).catch(data => {
					Toast('服务器错误，请重试');
					this.jz_flag = false
				})
			}

		},
		mounted() {
			
			if(!tokenss){
				var gettoken = setInterval(()=>{
					if(tokenss){
						clearInterval(gettoken)
						this.login()
					}
				},1000)
			}else{
				this.login()
			}
			
			fwl()
			document.title = "来冀云识春花，赢游戏，领米面油礼包"
			weixinshare("https://appapi.hebei.com.cn/ljyschyxpro/share.jpg",'来冀云识春花，赢游戏，领米面油礼包',"更多精彩内容，尽在冀云客户端","https://appapi.hebei.com.cn/ljyschyxpro/warm");
			
			if (!is_jiyun()) {
				this.jy_flag = false
				let requestData = {
					contentId: '06237ffb3fda426e9729abb2afd317b6', //
					contentType: "1",
					pubTime: "2026-03-12 09:32:01", //
					title: '来冀云识春花，赢游戏，领米面油礼包', //
					url: 'https://jiyun.hebyun.com.cn/pages/2026/03/12/06237ffb3fda426e9729abb2afd317b6.html', //
					siteId: "d78cdde3a4b0443eb8e4398ca4bc6473"
				}
				upData(requestData)
			}else{
				this.jy_flag = true
			}
		}
	}
</script>

<style scoped="scoped">
	.bg{
		background-image: url(../assets/bg3.jpg);
		background-size: 100% 100%;
	}
	.kuang{
		background-image: url(../assets/kuang.png);
		background-size: 100% 100%;
		margin: 0 auto;
		width: 90%;
		box-sizing: border-box;
		padding: 20px 15px;
		margin-top: 20px;
	}
	.yqm_div{
		position: relative;
		font-size: 0;
		width: 60%;
		margin: 0 auto;
		margin-top: 5px;
		
	}
	.yqm_text{
		position: absolute;top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		font-size: 1.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder;
	}
	.zyq_text{
		position: absolute;
		top: 0;
		left: 37.5%;
		height: 100%;
		font-size: 1.1rem;
		color: #4b7020;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder;
	}
	.wancheng{
		font-size: 1.1rem;
		color: #4b7020;
		font-weight: bolder;
		margin-top: 15px;
		text-align: center;
	}
	.yqmInput{
		width: 45%;
		border: none;
		outline: none;
		background-image: url(../assets/srkbg2.png);
		background-size: 100% 100%;
		font-size: 1.4rem;
		height: 45px;
		text-align: center;
		font-weight: bolder;
		margin-right: 15px;
	}
	.logo{
		width: 35%;
		position: absolute;
		bottom: 10px;
		left: 50%;
		transform: translateX(-50%);
	}
	.xiazai{
		width: 80%;
		height: 50px;
		background-color: #ffa31a;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		border-radius: 10px;
		margin: 0 auto;
		margin-top: 40px;
		font-size: 1.3rem;
	}
</style>
